import React from 'react'
import Desktop from './Desktop'
import Mobile from './Mobile'
// import { DndProvider } from 'react-dnd'
// import HTML5Backend from 'react-dnd-html5-backend'
// import TouchBackend from 'react-dnd-touch-backend'
// import MultiBackend, {
//   TouchTransition,
//   MouseTransition,
// } from 'react-dnd-multi-backend'
import EditorDialog from 'components/AddOrEditTaskPage/EditorDialog'

// const CustomHTML5toTouch = {
//   backends: [
//     {
//       backend: HTML5Backend,
//       transition: MouseTransition,
//       // preview: true,
//       // by default, will dispatch a duplicate `mousedown` event when this backend is activated
//     },
//     {
//       backend: TouchBackend,
//       // Note that you can call your backends with options
//       options: { enableMouseEvents: true },
//       preview: true,
//       transition: TouchTransition,
//     },
//   ],
// }

const TemplateForm = () => (
	<div style={{ height: '100%' }}>
		<>
			<Desktop />
			<Mobile />
		</>
		{/* <Hidden lgUp> */}
			<EditorDialog />
		{/* </Hidden> */}
	</div>
)

export default TemplateForm
